import { getTenant, getUserName } from '../../../hooks';
import * as sea from 'node:sea';

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const getUsersList = (successCallback, errorCallback, page, search) => {
  const currentTenant = getTenant();
  const queryParam = new URLSearchParams({
    platform_key: currentTenant,
    page,
    query: search,
  }).toString();
  const url =
    process.env.REACT_APP_IBL_DM_URL + '/api/core/platform/users?' + queryParam;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp
        .json()
        .then((data) => {
          successCallback(data);
          //successCallback({results:USERS_DATASET})
        })
        .catch((err) => {
          errorCallback();
        });
    })
    .catch((err) => {
      errorCallback();
    });
};

export const updateUserStatus = (
  data,
  successCallback,
  errorCallback,
  userData
) => {
  //const currentTenant = getTenant()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/core/users/platforms/`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp
        .json()
        .then((data) => {
          //successCallback(data);
          successCallback(userData);
        })
        .catch((err) => {
          //errorCallback()
          successCallback(userData);
        });
    })
    .catch((err) => {
      //errorCallback()
      successCallback(userData);
    });
};

export const updateUserRole = (
  data,
  successCallback,
  errorCallback,
  userData
) => {
  //const currentTenant = getTenant()
  const baseURL = process.env.REACT_APP_IBL_STUDIO_URL;
  const url = `${
    baseURL.endsWith('/') ? baseURL : baseURL + '/'
  }api/ibl/users/manage/roles/`;
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      //Authorization: 'Bearer ' + localStorage.getItem('axd_token'),
    },
  })
    .then((resp) => {
      resp
        .json()
        .then((role_data) => {
          //successCallback(role_data);
          successCallback(userData);
        })
        .catch((err) => {
          //errorCallback()
          successCallback(userData);
        });
    })
    .catch((err) => {
      //errorCallback()
      successCallback(userData);
    });
};

export const isEmailValid = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const inviteUserByEmail = (email, successCallback, errorCallback) => {
  const currentTenant = getTenant();
  const url =
    process.env.REACT_APP_IBL_DM_URL + '/api/catalog/invitations/platform/';
  const data = {
    email: email,
    platform_key: currentTenant,
    source: getUserName(),
    redirect_to: window.location.origin,
  };
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp
        .json()
        .then((data) => {
          successCallback(data);
          //successCallback({results:USERS_DATASET})
        })
        .catch((err) => {
          errorCallback();
        });
    })
    .catch((err) => {
      errorCallback();
    });
};

export const getInvitedUsersList = (
  successCallback,
  errorCallback,
  page,
  search
) => {
  const currentTenant = getTenant();
  const queryParam = new URLSearchParams({
    platform_key: currentTenant,
    page,
    query: search,
  }).toString();
  const url =
    process.env.REACT_APP_IBL_DM_URL +
    '/api/catalog/invitations/platform?' +
    queryParam;
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  })
    .then((resp) => {
      resp
        .json()
        .then((data) => {
          successCallback(data);
          //successCallback({results:USERS_DATASET})
        })
        .catch((err) => {
          errorCallback();
        });
    })
    .catch((err) => {
      errorCallback();
    });
};

export const handleConvertLineBreaksToHTML = (text:string) =>{
   return text.replace(/(\r\n|\n|\r)/g, "<br/>");
}

export const handleConvertHTMLBreaksToLineBreaks = (text:string) =>{
  return text.replace(/<br\s*\/?>/g, "\n");
}